var $ = require('jquery');
var isMobile = false; //initiate as false
function isAppleDevice(){
  return (
      (navigator.userAgent.toLowerCase().indexOf("ipad") > -1) ||
      (navigator.userAgent.toLowerCase().indexOf("iphone") > -1) ||
      (navigator.userAgent.toLowerCase().indexOf("ipod") > -1)
  );
}
$(function() {  
  function mobileToogle(){
 
  // if( $('#devicecheckdiv').css('display')=='block') {
  //   isMobile = true;       
  // }
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    isMobile = true; 
   }
    else if (isAppleDevice()) {
    isMobile = true; 
   }
  else{isMobile = false;}

  if (isMobile) {
    
    $(".filterblock").hide();
    $(".fundfilter").hide();
    $('.fundsfilterblock').hide();
      if (window.location.href.indexOf('/insight') > -1) {
        $(".resettxt").find("a").html("Reset");
      }
      else {
    $(".resettxt").find("a").html("Apply");
  }

    }
  else{
    $(".filterblock").show();
    $(".fundfilter").show();
    $('.fundsfilterblock').show();
      if (window.location.href.indexOf('/vn/insight') > -1) {
      $(".resettxt").find("a").html("Đặt lại");
    }
      else if (window.location.href.indexOf('/hk/zh-cht/insight') > -1) {
      $(".resettxt").find("a").html("重設");
    }
      else if (window.location.href.indexOf('.cn') > -1) {
      $(".resettxt").find("a").html("重置");
    }
      else if (window.location.href.indexOf('/id/publications') > -1) {
      $(".resettxt").find("a").html("Atur ulang");
    }
      else if (window.location.href.indexOf('uat-eastspringkr') > -1 || window.location.href.indexOf('eastspringinvestments.co.kr/') > -1) {
      $(".resettxt").find("a").html("리셋");
    }
      else if (window.location.href.indexOf('eastspringtw') > -1 || window.location.href.indexOf('.tw') > -1) {
      $(".resettxt").find("a").html("重新設定");
    }
      else if (window.location.href.indexOf('eastspringjp') > -1 || window.location.href.indexOf('.jp') > -1) {
      $(".resettxt").find("a").html("リセット");
    }
    else{
      $(".resettxt").find("a").html("Reset");
    }
  } 
}
mobileToogle();
$(window).resize(function(){
  mobileToogle();
});
$(document).on("click",".filtertxt, .fund-apply",function(){
 
  if (isMobile) {
    
    FilterClickDevice();
}
else{
  FilterClickDesktop();
}

});

  function FilterClickDesktop() {
  $(".fundfilter").toggle();
  $(".filterblock").toggleClass("filterblock-dis");
  $(".fundsblock").toggleClass("fundsblock-inc");
  $(".filterclose").toggle();
  $(".filteropen").toggle();
  $(".resettxt").toggle();
  $(".applytxt").toggle();
  var reseststatus = $(".resettxt").css("display");
  var filterheading = $(".filterheading").css("background");
  if (reseststatus == "inline"){
  $(".filterheading").css({"background":"#F2F3F4","padding":"24px"});
  }
  else{
    $(".filterheading").css({"background":"transparent","padding":"0"});
        
  }
}
$(document).on("click", ".Mfilterclose", function(){
  
  if (isMobile) {
    $(".filterblock").hide();
    $(".fundfilter").hide();
    $(".fundsfilterblock").hide();
   $('body').removeClass('hiddenOverflow');
   $('html, body').animate({
   scrollTop: $('.fundsfilterblock').offset().top - 1000 
    }, 'slow');
  }
});
  function FilterClickDevice() {
  $(".filterblock").toggle();
   $(".fundfilter").toggle();
    $('.fundsfilterblock').toggle();
  $('body').toggleClass('hiddenOverflow');
  $('html, body').animate({
  scrollTop: $('.fundsfilterblock').offset().top - 1000 
   }, 'slow');
}
});

 
  $('.moreless-button').click(function() {
    $('.moretext').slideToggle();
    if ($('.moreless-button').text() == "+ 5 more") {
      $(this).text("- 5 less")
    } else {
      $(this).text("+ 5 more")
    }
  });

  
$('.moreless-buttoncurrency').click(function() {
    $('.moretext').slideToggle();
    if ($('.moreless-buttoncurrency').text() == "+ 4 more") {
      $(this).text("- 4 less")
    } else {
      $(this).text("+ 4 more")
    }
  });

  
  